import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import { SessionContext } from "../context/session-context";



import ClientForm from "./ClientForm";
import OrderPanel from "./ClientOrderPanel";

const useStyles = makeStyles({
    root: {

    },
    selectContainer:{
        '& .MuiSelect-select.MuiSelect-select':{
            height: 'calc(100vh - 300px)',
        },
        marginTop:10,
        marginRight:10,
        border: '2px solid #3D3E4F',
    },
    selectObject:{
        width:'100%'
    },
    textItemFont:{
        fontSize:12
    },
    textField:{
        width:300
    },
    formContainer:{
        marginTop:25,
        padding:10,
        border: '1px solid',
        minHeight: 300,
    },
    modelLabel:{
        padding:10,
    },
    modelField:{
        width:'90%'
    },
    actionButton:{
        marginTop:8,
        marginLeft:10,
    }


  });

  var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

export default function ClientsPanel(props) {
    const classes = useStyles();
  
    const [sState, sDispatch] = useContext(SessionContext);
    const [selectedModel, setSelectedModel] = useState([]);
    const [selectedModelID, setSelectedModelID] = useState(0);
    const [modelRows, setModelRows] = useState([]);
    const [filterStr, setFilterStr] = useState('');
    const [hasUpdateRequest, setHasUpdateRequest] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    

    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);

    const [model_newname, setModel_newname] = useState('');
    const [hasNewname, setHasNewname] = useState(false);

    const [model_name, setModel_name] = useState('');
    const [model_description, setModel_description] = useState('');
    const [model_status, setModel_status] = useState('active');
    const [model_created, setModel_created] = useState('');

    const [model_os250_name, setModel_os250_name] = useState('');
    const [model_os250_product, setModel_os250_product] = useState('');
    const [model_os250_view_unit, setModel_os250_view_unit] = useState('');
    const [model_os250_view_price, setModel_os250_view_price] = useState(0);
    const [model_os250_view_royalty, setModel_os250_view_royalty] = useState('');
    const [model_os250_print_minFixed, setModel_os250_print_minFixed] = useState(0);
    const [model_os250_export_minFixed, setModel_os250_export_minFixed] = useState(0);

    const [model_os50_name, setModel_os50_name] = useState('');
    const [model_os50_product, setModel_os50_product] = useState('');
    const [model_os50_view_unit, setModel_os50_view_unit] = useState('');
    const [model_os50_view_price, setModel_os50_view_price] = useState(0);
    const [model_os50_view_royalty, setModel_os50_view_royalty] = useState('');
    const [model_os50_print_minFixed, setModel_os50_print_minFixed] = useState(0);
    const [model_os50_print_price, setModel_os50_print_price] = useState(0);
    const [model_os50_print_unit, setModel_os50_print_unit] = useState('');
    const [model_os50_print_royalty, setModel_os50_print_royalty] = useState('');
    const [model_os50_export_minFixed, setModel_os50_export_minFixed] = useState(0);
    const [model_os50_export_price, setModel_os50_export_price] = useState(0);
    const [model_os50_export_unit, setModel_os50_export_unit] = useState('');
    const [model_os50_export_royalty, setModel_os50_export_royalty] = useState('');

    const [model_osvmd_name, setModel_osvmd_name] = useState('');
    const [model_osvmd_product, setModel_osvmd_product] = useState('');
    const [model_osvmd_view_unit, setModel_osvmd_view_unit] = useState('');
    const [model_osvmd_view_price, setModel_osvmd_view_price] = useState(0);
    const [model_osvmd_view_royalty, setModel_osvmd_view_royalty] = useState('');
    const [model_osvmd_print_minFixed, setModel_osvmd_print_minFixed] = useState(0);
    const [model_osvmd_print_price, setModel_osvmd_print_price] = useState('');
    const [model_osvmd_print_unit, setModel_osvmd_print_unit] = useState('');
    const [model_osvmd_print_royalty, setModel_osvmd_print_royalty] = useState('');
    const [model_osvmd_export_minFixed, setModel_osvmd_export_minFixed] = useState(0);
    const [model_osvmd_export_price, setModel_osvmd_export_price] = useState('');
    const [model_osvmd_export_unit, setModel_osvmd_export_unit] = useState('');
    const [model_osvmd_export_royalty, setModel_osvmd_export_royalty] = useState('');

    const [model_osoml_name, setModel_osoml_name] = useState('');
    const [model_osoml_product, setModel_osoml_product] = useState('');
    const [model_osoml_view_unit, setModel_osoml_view_unit] = useState('');
    const [model_osoml_view_price, setModel_osoml_view_price] = useState(0);
    const [model_osoml_view_royalty, setModel_osoml_view_royalty] = useState('');
    const [model_osoml_print_minFixed, setModel_osoml_print_minFixed] = useState(0);
    const [model_osoml_print_price, setModel_osoml_print_price] = useState('');
    const [model_osoml_print_unit, setModel_osoml_print_unit] = useState('');
    const [model_osoml_print_royalty, setModel_osoml_print_royalty] = useState('');
    const [model_osoml_export_minFixed, setModel_osoml_export_minFixed] = useState(0);
    const [model_osoml_export_price, setModel_osoml_export_price] = useState('');
    const [model_osoml_export_unit, setModel_osoml_export_unit] = useState('');
    const [model_osoml_export_royalty, setModel_osoml_export_royalty] = useState('');

    const [model_osvml_name, setModel_osvml_name] = useState('');
    const [model_osvml_product, setModel_osvml_product] = useState('');
    const [model_osvml_view_unit, setModel_osvml_view_unit] = useState('');
    const [model_osvml_view_threshold_band, setModel_osvml_view_threshold_band] = useState('');
    const [model_osvml_view_threshold_lower, setModel_osvml_view_threshold_lower] = useState('');
    const [model_osvml_view_threshold_higher, setModel_osvml_view_threshold_higher] = useState('');
    const [model_osvml_view_threshold_price, setModel_osvml_view_threshold_price] = useState(0);
    const [model_osvml_view_threshold_royalty, setModel_osvml_view_threshold_royalty] = useState('');
    const [model_osvml_view_band1_band, setModel_osvml_view_band1_band] = useState('');
    const [model_osvml_view_band1_lower, setModel_osvml_view_band1_lower] = useState('');
    const [model_osvml_view_band1_higher, setModel_osvml_view_band1_higher] = useState('');
    const [model_osvml_view_band1_price, setModel_osvml_view_band1_price] = useState(0);
    const [model_osvml_view_band1_royalty, setModel_osvml_view_band1_royalty] = useState('');

    const [model_osvml_print_minFixed, setModel_osvml_print_minFixed] = useState(0);
    const [model_osvml_print_unit, setModel_osvml_print_unit] = useState('');
    const [model_osvml_print_threshold_band, setModel_osvml_print_threshold_band] = useState('');
    const [model_osvml_print_threshold_lower, setModel_osvml_print_threshold_lower] = useState('');
    const [model_osvml_print_threshold_higher, setModel_osvml_print_threshold_higher] = useState('');
    const [model_osvml_print_threshold_price, setModel_osvml_print_threshold_price] = useState(0);
    const [model_osvml_print_threshold_royalty, setModel_osvml_print_threshold_royalty] = useState('');
    const [model_osvml_print_band1_band, setModel_osvml_print_band1_band] = useState('');
    const [model_osvml_print_band1_lower, setModel_osvml_print_band1_lower] = useState('');
    const [model_osvml_print_band1_higher, setModel_osvml_print_band1_higher] = useState('');
    const [model_osvml_print_band1_price, setModel_osvml_print_band1_price] = useState(0);
    const [model_osvml_print_band1_royalty, setModel_osvml_print_band1_royalty] = useState('');

    const [model_osvml_export_minFixed, setModel_osvml_export_minFixed] = useState(0);
    const [model_osvml_export_unit, setModel_osvml_export_unit] = useState('');
    const [model_osvml_export_threshold_price, setModel_osvml_export_threshold_price] = useState(0);
    const [model_osvml_export_band1_band, setModel_osvml_export_band1_band] = useState('');
    const [model_osvml_export_band1_lower, setModel_osvml_export_band1_lower] = useState('');
    const [model_osvml_export_band1_higher, setModel_osvml_export_band1_higher] = useState('');
    const [model_osvml_export_band1_price, setModel_osvml_export_band1_price] = useState(0);
    const [model_osvml_export_band1_royalty, setModel_osvml_export_band1_royalty] = useState('');

    const [model_osmm_name, setModel_osmm_name] = useState('');
    const [model_osmm_product, setModel_osmm_product] = useState('');
    const [model_osmm_view_unit, setModel_osmm_view_unit] = useState('');
    const [model_osmm_view_threshold_band, setModel_osmm_view_threshold_band] = useState('');
    const [model_osmm_view_threshold_lower, setModel_osmm_view_threshold_lower] = useState('');
    const [model_osmm_view_threshold_higher, setModel_osmm_view_threshold_higher] = useState('');
    const [model_osmm_view_threshold_price, setModel_osmm_view_threshold_price] = useState(0);
    const [model_osmm_view_threshold_royalty, setModel_osmm_view_threshold_royalty] = useState('');

    const [model_osmm_view_band1_band, setModel_osmm_view_band1_band] = useState('');
    const [model_osmm_view_band1_lower, setModel_osmm_view_band1_lower] = useState('');
    const [model_osmm_view_band1_high_price, setModel_osmm_view_band1_high_price] = useState(0);
    const [model_osmm_view_band1_high_royalty, setModel_osmm_view_band1_high_royalty] = useState('');
    const [model_osmm_view_band1_med_price, setModel_osmm_view_band1_med_price] = useState(0);
    const [model_osmm_view_band1_med_royalty, setModel_osmm_view_band1_med_royalty] = useState('');
    const [model_osmm_view_band1_low_price, setModel_osmm_view_band1_low_price] = useState(0);
    const [model_osmm_view_band1_low_royalty, setModel_osmm_view_band1_low_royalty] = useState('');

    const [model_osmm_view_band2_band, setModel_osmm_view_band2_band] = useState('');
    const [model_osmm_view_band2_lower, setModel_osmm_view_band2_lower] = useState('');
    const [model_osmm_view_band2_high_price, setModel_osmm_view_band2_high_price] = useState(0);
    const [model_osmm_view_band2_high_royalty, setModel_osmm_view_band2_high_royalty] = useState('');
    const [model_osmm_view_band2_med_price, setModel_osmm_view_band2_med_price] = useState(0);
    const [model_osmm_view_band2_med_royalty, setModel_osmm_view_band2_med_royalty] = useState('');
    const [model_osmm_view_band2_low_price, setModel_osmm_view_band2_low_price] = useState(0);
    const [model_osmm_view_band2_low_royalty, setModel_osmm_view_band2_low_royalty] = useState('');

    const [model_osmm_print_200_a4, setModel_osmm_print_200_a4] = useState(0);
    const [model_osmm_print_200_a3, setModel_osmm_print_200_a3] = useState(0);
    const [model_osmm_print_200_a2, setModel_osmm_print_200_a2] = useState('');
    const [model_osmm_print_200_a1, setModel_osmm_print_200_a1] = useState('');
    const [model_osmm_print_200_a0, setModel_osmm_print_200_a0] = useState('');

    const [model_osmm_print_500_a4, setModel_osmm_print_500_a4] = useState(0);
    const [model_osmm_print_500_a3, setModel_osmm_print_500_a3] = useState(0);
    const [model_osmm_print_500_a2, setModel_osmm_print_500_a2] = useState('');
    const [model_osmm_print_500_a1, setModel_osmm_print_500_a1] = useState('');
    const [model_osmm_print_500_a0, setModel_osmm_print_500_a0] = useState('');

    const [model_osmm_print_1250_a4, setModel_osmm_print_1250_a4] = useState(0);
    const [model_osmm_print_1250_a3, setModel_osmm_print_1250_a3] = useState(0);
    const [model_osmm_print_1250_a2, setModel_osmm_print_1250_a2] = useState('');
    const [model_osmm_print_1250_a1, setModel_osmm_print_1250_a1] = useState('');
    const [model_osmm_print_1250_a0, setModel_osmm_print_1250_a0] = useState('');

    const [model_osmm_print_2500_a4, setModel_osmm_print_2500_a4] = useState(0);
    const [model_osmm_print_2500_a3, setModel_osmm_print_2500_a3] = useState(0);
    const [model_osmm_print_2500_a2, setModel_osmm_print_2500_a2] = useState('');
    const [model_osmm_print_2500_a1, setModel_osmm_print_2500_a1] = useState('');
    const [model_osmm_print_2500_a0, setModel_osmm_print_2500_a0] = useState('');

    const [model_osmm_print_threshold_lower, setModel_osmm_print_threshold_lower] = useState('');
    const [model_osmm_print_threshold_higher, setModel_osmm_print_threshold_higher] = useState('');
    const [model_osmm_print_threshold_price, setModel_osmm_print_threshold_price] = useState('');
    const [model_osmm_print_threshold_royalty, setModel_osmm_print_threshold_royalty] = useState('');
    const [model_osmm_print_threshold_unit, setModel_osmm_print_threshold_unit] = useState('');

    const [model_osmm_print_band1_lower, setModel_osmm_print_band1_lower] = useState('');
    const [model_osmm_print_band1_higher, setModel_osmm_print_band1_higher] = useState('');
    const [model_osmm_print_band1_high_price, setModel_osmm_print_band1_high_price] = useState('');
    const [model_osmm_print_band1_high_royalty, setModel_osmm_print_band1_high_royalty] = useState('');
    const [model_osmm_print_band1_med_price, setModel_osmm_print_band1_med_price] = useState('');
    const [model_osmm_print_band1_med_royalty, setModel_osmm_print_band1_med_royalty] = useState('');
    const [model_osmm_print_band1_low_price, setModel_osmm_print_band1_low_price] = useState('');
    const [model_osmm_print_band1_low_royalty, setModel_osmm_print_band1_low_royalty] = useState('');

    const [model_osmm_print_band2_lower, setModel_osmm_print_band2_lower] = useState('');
    const [model_osmm_print_band2_higher, setModel_osmm_print_band2_higher] = useState('');
    const [model_osmm_print_band2_high_price, setModel_osmm_print_band2_high_price] = useState('');
    const [model_osmm_print_band2_high_royalty, setModel_osmm_print_band2_high_royalty] = useState('');
    const [model_osmm_print_band2_med_price, setModel_osmm_print_band2_med_price] = useState('');
    const [model_osmm_print_band2_med_royalty, setModel_osmm_print_band2_med_royalty] = useState('');
    const [model_osmm_print_band2_low_price, setModel_osmm_print_band2_low_price] = useState('');
    const [model_osmm_print_band2_low_royalty, setModel_osmm_print_band2_low_royalty] = useState('');

    const [model_osmm_export_minFixed, setModel_osmm_export_minFixed] = useState(0);
    const [model_osmm_export_fixed_1ha, setModel_osmm_export_fixed_1ha] = useState(0);
    const [model_osmm_export_fixed_4ha, setModel_osmm_export_fixed_4ha] = useState(0);
    const [model_osmm_export_threshold_lower, setModel_osmm_export_threshold_lower] = useState('');
    const [model_osmm_export_threshold_higher, setModel_osmm_export_threshold_higher] = useState('');
    const [model_osmm_export_threshold_price, setModel_osmm_export_threshold_price] = useState(0);
    const [model_osmm_export_threshold_royalty, setModel_osmm_export_threshold_royalty] = useState('');
    const [model_osmm_export_threshold_unit, setModel_osmm_export_threshold_unit] = useState('');

    const [model_osmm_export_band1_lower, setModel_osmm_export_band1_lower] = useState('');
    const [model_osmm_export_band1_higher, setModel_osmm_export_band1_higher] = useState('');
    const [model_osmm_export_band1_high_price, setModel_osmm_export_band1_high_price] = useState(0);
    const [model_osmm_export_band1_high_royalty, setModel_osmm_export_band1_high_royalty] = useState('');
    const [model_osmm_export_band1_med_price, setModel_osmm_export_band1_med_price] = useState(0);
    const [model_osmm_export_band1_med_royalty, setModel_osmm_export_band1_med_royalty] = useState('');
    const [model_osmm_export_band1_low_price, setModel_osmm_export_band1_low_price] = useState(0);
    const [model_osmm_export_band1_low_royalty, setModel_osmm_export_band1_low_royalty] = useState('');

    const [model_osmm_export_band2_lower, setModel_osmm_export_band2_lower] = useState('');
    const [model_osmm_export_band2_higher, setModel_osmm_export_band2_higher] = useState('');
    const [model_osmm_export_band2_high_price, setModel_osmm_export_band2_high_price] = useState(0);
    const [model_osmm_export_band2_high_royalty, setModel_osmm_export_band2_high_royalty] = useState('');
    const [model_osmm_export_band2_med_price, setModel_osmm_export_band2_med_price] = useState(0);
    const [model_osmm_export_band2_med_royalty, setModel_osmm_export_band2_med_royalty] = useState('');
    const [model_osmm_export_band2_low_price, setModel_osmm_export_band2_low_price] = useState(0);
    const [model_osmm_export_band2_low_royalty, setModel_osmm_export_band2_low_royalty] = useState('');

    const [model_aerial_name, setModel_aerial_name] = useState('');
    const [model_aerial_product, setModel_aerial_product] = useState('');
    const [model_aerial_view_unit, setModel_aerial_view_unit] = useState('');
    const [model_aerial_view_threshold_band, setModel_aerial_view_threshold_band] = useState('');
    const [model_aerial_view_threshold_lower, setModel_aerial_view_threshold_lower] = useState('');
    const [model_aerial_view_threshold_higher, setModel_aerial_view_threshold_higher] = useState('');
    const [model_aerial_view_threshold_unit, setModel_aerial_view_threshold_unit] = useState('');
    const [model_aerial_view_threshold_price, setModel_aerial_view_threshold_price] = useState(0);
    const [model_aerial_view_threshold_royalty, setModel_aerial_view_threshold_royalty] = useState('');
    const [model_aerial_view_threshold_maxScale, setModel_aerial_view_threshold_maxScale] = useState('');

    const [model_aerial_print_minFixed, setModel_aerial_print_minFixed] = useState('');
    const [model_aerial_print_unit, setModel_aerial_print_unit] = useState('');
    const [model_aerial_print_threshold_band, setModel_aerial_print_threshold_band] = useState('');
    const [model_aerial_print_threshold_lower, setModel_aerial_print_threshold_lower] = useState('');
    const [model_aerial_print_threshold_higher, setModel_aerial_print_threshold_higher] = useState('');
    const [model_aerial_print_threshold_price, setModel_aerial_print_threshold_price] = useState(0);
    const [model_aerial_print_threshold_royalty, setModel_aerial_print_threshold_royalty] = useState('');
    const [model_aerial_print_threshold_maxScale, setModel_aerial_print_threshold_maxScale] = useState('');
    const [model_aerial_print_band1_band, setModel_aerial_print_band1_band] = useState('');
    const [model_aerial_print_band1_lower, setModel_aerial_print_band1_lower] = useState('');
    const [model_aerial_print_band1_higher, setModel_aerial_print_band1_higher] = useState('');
    const [model_aerial_print_band1_price, setModel_aerial_print_band1_price] = useState(0);
    const [model_aerial_print_band1_royalty, setModel_aerial_print_band1_royalty] = useState('');
    const [model_aerial_print_band1_maxScale, setModel_aerial_print_band1_maxScale] = useState('');
    const [model_aerial_print_band2_band, setModel_aerial_print_band2_band] = useState('');
    const [model_aerial_print_band2_lower, setModel_aerial_print_band2_lower] = useState('');
    const [model_aerial_print_band2_higher, setModel_aerial_print_band2_higher] = useState('');
    const [model_aerial_print_band2_price, setModel_aerial_print_band2_price] = useState('');
    const [model_aerial_print_band2_royalty, setModel_aerial_print_band2_royalty] = useState('');
    const [model_aerial_print_band2_maxScale, setModel_aerial_print_band2_maxScale] = useState('');
    const [model_aerial_print_band3_band, setModel_aerial_print_band3_band] = useState('');
    const [model_aerial_print_band3_lower, setModel_aerial_print_band3_lower] = useState('');
    const [model_aerial_print_band3_higher, setModel_aerial_print_band3_higher] = useState('');
    const [model_aerial_print_band3_price, setModel_aerial_print_band3_price] = useState('');
    const [model_aerial_print_band3_royalty, setModel_aerial_print_band3_royalty] = useState('');
    const [model_aerial_print_band3_maxScale, setModel_aerial_print_band3_maxScale] = useState('');

    /**
     * First load
     */
    useEffect(() => {

        getPricingLists();

    },[])

    const getPricingLists = () =>{
        setHasLoaded(false);
        const abortController = new AbortController();

        let mounted = true;
        (async () => {  
          const res = await fetch(process.env.REACT_APP_FIND_API+'/admin/pricingmodel', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            signal: abortController.signal,
          }).catch(handleError);
          const data = await res.json();
          if (mounted) {
            if (data.status === "success"){
                setHasLoaded(true);
                setModelRows(data.data);
            } else {
                setModelRows([]);
            }
          }
          const cleanup = () => {
            mounted = false;
            abortController.abort();
          };
          return cleanup;
      
      })();
    }

    useEffect(() => {
        for (let c of modelRows) {
            if (parseInt(c.modelid) === parseInt(selectedModelID)){
                setSelectedModel(c);
                break;
            }
        }   
    },[selectedModelID])

    
    useEffect(() => {

        if (hasLoaded){

            setModel_name(selectedModel.name);
            setModel_description(selectedModel.description);
            setModel_status(selectedModel.status);
            setModel_created(selectedModel.created)
    
            setModel_os250_view_price(selectedModel.model.os250k.view.price);
            setModel_os250_print_minFixed(selectedModel.model.os250k.print.fixed.minFixed);
            setModel_os250_export_minFixed(selectedModel.model.os250k.export.fixed.minFixed);
    
            setModel_os50_view_price(selectedModel.model.os50k.view.price);
            setModel_os50_print_minFixed(selectedModel.model.os50k.print.fixed.minFixed);
            setModel_os50_print_price(selectedModel.model.os50k.print.band1.price);
            setModel_os50_export_minFixed(selectedModel.model.os50k.export.fixed.minFixed);
            setModel_os50_export_price(selectedModel.model.os50k.export.band1.price);
    
            setModel_osvmd_view_price(selectedModel.model.os25k.view.price);
            setModel_osvmd_print_minFixed(selectedModel.model.os25k.print.fixed.minFixed);
            setModel_osvmd_export_minFixed(selectedModel.model.os25k.export.fixed.minFixed);
    
            setModel_osoml_view_price(selectedModel.model.oml.view.price);
            setModel_osoml_print_minFixed(selectedModel.model.oml.print.fixed.minFixed);
            setModel_osoml_export_minFixed(selectedModel.model.oml.export.fixed.minFixed);
    
            setModel_osvml_view_threshold_price(selectedModel.model.vml.view.threshold.price);
            setModel_osvml_view_band1_price(selectedModel.model.vml.view.band1.price);
            setModel_osvml_print_minFixed(selectedModel.model.vml.print.fixed.minFixed);
            setModel_osvml_print_threshold_price(selectedModel.model.vml.print.threshold.price);
            setModel_osvml_print_band1_price(selectedModel.model.vml.print.band1.price);
            setModel_osvml_export_minFixed(selectedModel.model.vml.export.fixed.minFixed);
            setModel_osvml_export_threshold_price(selectedModel.model.vml.export.threshold.price);
            setModel_osvml_export_band1_price(selectedModel.model.vml.export.band1.price);
    
            setModel_osmm_view_threshold_price(selectedModel.model.osmm.view.threshold.price);
            setModel_osmm_view_band1_high_price(selectedModel.model.osmm.view.band1.high.price);
            setModel_osmm_view_band1_med_price(selectedModel.model.osmm.view.band1.med.price);
            setModel_osmm_view_band1_low_price(selectedModel.model.osmm.view.band1.low.price);
            setModel_osmm_view_band2_high_price(selectedModel.model.osmm.view.band2.high.price);
            setModel_osmm_view_band2_med_price(selectedModel.model.osmm.view.band2.med.price);
            setModel_osmm_view_band2_low_price(selectedModel.model.osmm.view.band2.low.price);

            setModel_osmm_print_200_a4(selectedModel.model.osmm.print.scale200.a4.price);
            setModel_osmm_print_200_a3(selectedModel.model.osmm.print.scale200.a3.price);
            setModel_osmm_print_500_a4(selectedModel.model.osmm.print.scale500.a4.price);
            setModel_osmm_print_500_a3(selectedModel.model.osmm.print.scale500.a3.price);
            setModel_osmm_print_1250_a4(selectedModel.model.osmm.print.scale1250.a4.price);
            setModel_osmm_print_1250_a3(selectedModel.model.osmm.print.scale1250.a3.price);
            setModel_osmm_print_2500_a4(selectedModel.model.osmm.print.scale2500.a4.price);
            setModel_osmm_print_2500_a3(selectedModel.model.osmm.print.scale2500.a3.price);
            setModel_osmm_print_threshold_price(selectedModel.model.osmm.print.threshold.price);
            setModel_osmm_print_band1_high_price(selectedModel.model.osmm.print.band1.bandhigh);
            setModel_osmm_print_band1_med_price(selectedModel.model.osmm.print.band1.bandmed);
            setModel_osmm_print_band1_low_price(selectedModel.model.osmm.print.band1.bandlow);
            setModel_osmm_print_band2_high_price(selectedModel.model.osmm.print.band2.bandhigh);
            setModel_osmm_print_band2_med_price(selectedModel.model.osmm.print.band2.bandmed);
            setModel_osmm_print_band2_low_price(selectedModel.model.osmm.print.band2.bandlow);

            setModel_osmm_export_minFixed(selectedModel.model.osmm.export.fixed.minFixed);
            setModel_osmm_export_fixed_1ha(selectedModel.model.osmm.export.fixed.area1ha);
            setModel_osmm_export_fixed_4ha(selectedModel.model.osmm.export.fixed.area4ha);
            setModel_osmm_export_threshold_price(selectedModel.model.osmm.export.threshold.price);
            setModel_osmm_export_band1_high_price(selectedModel.model.osmm.export.band1.high.price);
            setModel_osmm_export_band1_med_price(selectedModel.model.osmm.export.band1.med.price);
            setModel_osmm_export_band1_low_price(selectedModel.model.osmm.export.band1.low.price);
            setModel_osmm_export_band2_high_price(selectedModel.model.osmm.export.band2.high.price);
            setModel_osmm_export_band2_med_price(selectedModel.model.osmm.export.band2.med.price);
            setModel_osmm_export_band2_low_price(selectedModel.model.osmm.export.band2.low.price);

            setModel_aerial_view_threshold_price(selectedModel.model.aerial.view.threshold.price);
            setModel_aerial_print_threshold_price(selectedModel.model.aerial.print.threshold.price);
            setModel_aerial_print_band1_price(selectedModel.model.aerial.print.band1.price);
        }

    },[selectedModel])

    const doModelSave=()=>{
        let canSave = false;
        let request = {};
        for (let selectedModel of modelRows) {
            if (parseInt(selectedModel.modelid) === parseInt(selectedModelID)){
                
                request.name = model_name;
                request.description = model_description;
                const priceM = populateModel(selectedModel);
                request.model = priceM.model;
                request.status = model_status;
                request.modelid = parseInt(selectedModelID);
                canSave = true;
                break;
            }
        }   

        if (canSave){

            const abortController = new AbortController();
            let mounted = true;
            (async () => {  
                const res = await fetch(process.env.REACT_APP_FIND_API+'/admin/pricingmodel/update', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(request),
                signal: abortController.signal,
                }).catch(handleError);
                const data = await res.json();
                if (mounted) {
                    if (data.status === "success"){
                        setSeverity('success')
                        setMsg('Pricing model has been updated.')
                        setSnackOpen(true);
                    }
                }
                const cleanup = () => {
                    mounted = false;
                    abortController.abort();
                };
                return cleanup;
            
            })();
        }



    }

    const doModelNewSave=()=>{
        let canSave = false;
        const request = {};
        for (let selectedModel of modelRows) {
            if (parseInt(selectedModel.modelid) === parseInt(selectedModelID)){
                
                request.name = model_newname;
                request.description = model_description;
                const priceM = populateModel(selectedModel);
                request.model = priceM.model;
                request.modelid = -1;
                canSave = true;
                break;
            }
        }   
        if (canSave){
            const abortController = new AbortController();
            let mounted = true;
            (async () => {  
                const res = await fetch(process.env.REACT_APP_FIND_API+'/admin/pricingmodel/save', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(request),
                signal: abortController.signal,
                }).catch(handleError);
                const data = await res.json();
                if (mounted) {
                    if (data.status === "success"){
                        setSeverity('success')
                        setMsg('Pricing model has been added.')
                        setSnackOpen(true);
                    }
                }
                const cleanup = () => {
                    mounted = false;
                    abortController.abort();
                };
                return cleanup;
            
            })();
        }
        
    }

    const populateModel=(selectedModel)=>{
 
        selectedModel.name = model_name;
        selectedModel.description = model_description;
        selectedModel.status = model_status;
        selectedModel.created = model_created;

        selectedModel.model.os250k.view.price = model_os250_view_price;
        selectedModel.model.os250k.print.fixed.minFixed = model_os250_print_minFixed;
        selectedModel.model.os250k.export.fixed.minFixed = model_os250_export_minFixed;

        selectedModel.model.os50k.view.price = model_os50_view_price;
        selectedModel.model.os50k.print.fixed.minFixed = model_os50_print_minFixed;
        selectedModel.model.os50k.print.band1.price = model_os50_print_price;
        selectedModel.model.os50k.export.fixed.minFixed = model_os50_export_minFixed;
        selectedModel.model.os50k.export.band1.price = model_os50_export_price;

        selectedModel.model.os25k.view.price = model_osvmd_view_price;
        selectedModel.model.os25k.print.fixed.minFixed = model_osvmd_print_minFixed;
        selectedModel.model.os25k.export.fixed.minFixed = model_osvmd_export_minFixed;
        selectedModel.model.oml.view.price = model_osoml_view_price;
        selectedModel.model.oml.print.fixed.minFixed = model_osoml_print_minFixed;
        selectedModel.model.oml.export.fixed.minFixed = model_osoml_export_minFixed;

        selectedModel.model.vml.view.threshold.price = model_osvml_view_threshold_price;
        selectedModel.model.vml.view.band1.price = model_osvml_view_band1_price;
        selectedModel.model.vml.print.fixed.minFixed = model_osvml_print_minFixed;
        selectedModel.model.vml.print.threshold.price = model_osvml_print_threshold_price;
        selectedModel.model.vml.print.band1.price = model_osvml_print_band1_price;
        selectedModel.model.vml.export.fixed.minFixed = model_osvml_export_minFixed;
        selectedModel.model.vml.export.threshold.price = model_osvml_export_threshold_price;
        selectedModel.model.vml.export.band1.price = model_osoml_export_minFixed;

        selectedModel.model.osmm.view.threshold.price = model_osmm_view_threshold_price;
        selectedModel.model.osmm.view.band1.high.price = model_osmm_view_band1_high_price;
        selectedModel.model.osmm.view.band1.med.price = model_osmm_view_band1_med_price;
        selectedModel.model.osmm.view.band1.low.price = model_osmm_view_band1_low_price;
        selectedModel.model.osmm.view.band2.high.price = model_osmm_view_band2_high_price;
        selectedModel.model.osmm.view.band2.med.price = model_osmm_view_band2_med_price;
        selectedModel.model.osmm.view.band2.low.price = model_osmm_view_band2_low_price;

        selectedModel.model.osmm.print.scale200.a4.price = model_osmm_print_200_a4;
        selectedModel.model.osmm.print.scale200.a3.price = model_osmm_print_200_a3;
        selectedModel.model.osmm.print.scale500.a4.price = model_osmm_print_500_a4;
        selectedModel.model.osmm.print.scale500.a3.price = model_osmm_print_500_a3;
        selectedModel.model.osmm.print.scale1250.a4.price = model_osmm_print_1250_a4;
        selectedModel.model.osmm.print.scale1250.a3.price = model_osmm_print_1250_a3;
        selectedModel.model.osmm.print.scale2500.a4.price = model_osmm_print_2500_a4;
        selectedModel.model.osmm.print.scale2500.a3.price = model_osmm_print_2500_a3;
        selectedModel.model.osmm.print.threshold.price = model_osmm_print_threshold_price;
        selectedModel.model.osmm.print.band1.bandhigh = model_osmm_print_band1_high_price;
        selectedModel.model.osmm.print.band1.bandmed = model_osmm_print_band1_med_price;
        selectedModel.model.osmm.print.band1.bandlow = model_osmm_print_band1_low_price;
        selectedModel.model.osmm.print.band2.bandhigh = model_osmm_print_band2_high_price;
        selectedModel.model.osmm.print.band2.bandmed = model_osmm_print_band2_med_price;
        selectedModel.model.osmm.print.band2.bandlow = model_osmm_print_band2_low_price;

        selectedModel.model.osmm.export.fixed.minFixed = model_osmm_export_minFixed;
        selectedModel.model.osmm.export.fixed.area1ha = model_osmm_export_fixed_1ha;
        selectedModel.model.osmm.export.fixed.area4ha = model_osmm_export_fixed_4ha;
        selectedModel.model.osmm.export.threshold.price = model_osmm_export_threshold_price;
        selectedModel.model.osmm.export.band1.high.price = model_osmm_export_band1_high_price;
        selectedModel.model.osmm.export.band1.med.price = model_osmm_export_band1_med_price;
        selectedModel.model.osmm.export.band1.low.price = model_osmm_export_band1_low_price;
        selectedModel.model.osmm.export.band2.high.price = model_osmm_export_band2_high_price;
        selectedModel.model.osmm.export.band2.med.price = model_osmm_export_band2_med_price;
        selectedModel.model.osmm.export.band2.low.price = model_osmm_export_band2_low_price;

        selectedModel.model.aerial.view.threshold.price = model_aerial_view_threshold_price;
        selectedModel.model.aerial.print.threshold.price = model_aerial_print_threshold_price;
        selectedModel.model.aerial.print.band1.price = model_aerial_print_band1_price;

        return selectedModel;
    }


    useEffect(() => {
        if (model_newname.length > 3 && model_created !== ''){ setHasNewname(true); } else { setHasNewname(false);}
    },[model_newname, model_created])

    const handleSnackClose=()=>{
        setSnackOpen(false);
        getPricingLists();

    }

    return (
        <div className={classes.root}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackOpen}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                TransitionComponent={Slide}
                TransitionProps={{ direction: 'down' }}
            >
                <Alert onClose={handleSnackClose} severity={severity}>
                {msg}
                </Alert>
            </Snackbar>
            <Grid container>
                <Grid item xs={12}>
                    <Box className={classes.formLabel} fontWeight="500" fontStyle="italic" fontSize={22} >Pricing Models</Box>
                </Grid>
                <Grid item xs={5}>
                    <TextField className={classes.textField} name="pModel" label="Pricing Models" size="small" margin="dense" variant="outlined" value={selectedModelID} onChange={e => setSelectedModelID(e.target.value)} select>
                        {modelRows.map((item, i) => (
                            <MenuItem key={i} value={item.modelid}>{item.name}</MenuItem>
                        ))}
                    </TextField>  
                    <Button className={classes.actionButton} variant="contained" onClick={doModelSave} >
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Save</Box>
                    </Button>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={6}>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="model_newname" label="New pricing model name" size="small" margin="dense" variant="outlined" value={model_newname} onChange={e => setModel_newname(e.target.value)}/>
                    <Button className={classes.actionButton} variant="contained" onClick={doModelNewSave} disabled={!hasNewname}>
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Save as new model</Box>
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.formContainer} >
                        <Grid container>
                            <Grid item xs={12}>
                                <Box className={classes.modelLabel} fontWeight="500" fontStyle="italic" fontSize={16} >Pricing Model details</Box>
                            </Grid>
                            <Grid item xs={2}>
                                <TextField className={classes.modelField} name="modelid" label="Pricing Model ID" size="small" margin="dense" variant="outlined" value={selectedModelID} />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField className={classes.modelField} name="modelname" label="Pricing Model Name" size="small" margin="dense" variant="outlined" value={model_name} onChange={e => setModel_name(e.target.value)} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField className={classes.modelField} name="modeldescription" label="Pricing Model Description" size="small" margin="dense" variant="outlined" value={model_description} onChange={e => setModel_description(e.target.value)} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField className={classes.modelField} name="modelstatus" label="Status" size="small" margin="dense" variant="outlined" value={model_status} onChange={e => setModel_status(e.target.value)} select >
                                    <MenuItem value={'active'}>Active</MenuItem>
                                    <MenuItem value={'disabled'}>Disabled</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField className={classes.modelField} name="modelcreated" label="Created" size="small" margin="dense" variant="outlined" value={model_created} onChange={e => setModel_created(e.target.value)} />
                            </Grid>
                            <Grid item xs={6} />
                            <Grid item xs={12} >
                            <div className={classes.productcontainer}>
                                <Box className={classes.containerLabel} fontWeight="500" fontStyle="italic" fontSize={16} >OS 1:250,000 Raster</Box>
                                <Box className={classes.containerLabel} fontSize={12} >Views</Box>
                                <Grid container>
                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Price per km</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os250_view_price} onChange={e => setModel_os250_view_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>
                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Plots</Box>
                                <Grid container>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum plot price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os250_print_minFixed} onChange={e => setModel_os250_print_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>

                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Data</Box>
                                <Grid container>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum data price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os250_export_minFixed} onChange={e => setModel_os250_export_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>
                                </Grid>
                            </div>
                            </Grid>
                            <Grid item xs={12} >
                            <div className={classes.productcontainer}>
                                <Box className={classes.containerLabel} fontWeight="500" fontStyle="italic" fontSize={16} >OS 1:50,000 Raster</Box>
                                <Box className={classes.containerLabel} fontSize={12} >Views</Box>
                                <Grid container>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Price per km</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os50_view_price} onChange={e => setModel_os50_view_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>

                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Plots</Box>
                                <Grid container>
                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum plot price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os50_print_minFixed} onChange={e => setModel_os50_print_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Price per km</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os50_print_price} onChange={e => setModel_os50_print_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>

                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Data</Box>
                                <Grid container>
                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum data price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os50_export_minFixed} onChange={e => setModel_os50_export_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Price per km</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_os50_export_price} onChange={e => setModel_os50_export_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>
                                </Grid>
                            </div>
                            </Grid>
                            <Grid item xs={12} >
                            <div className={classes.productcontainer}>

                                <Box className={classes.containerLabel} fontWeight="500" fontStyle="italic" fontSize={16} >Ordnance Survey Vectormap District</Box>
                                <Box className={classes.containerLabel} fontSize={12} >Views</Box>
                                <Grid container>
                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Price per km</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_osvmd_view_price} onChange={e => setModel_osvmd_view_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>
                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Plots</Box>
                                <Grid container>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum plot price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_osvmd_print_minFixed} onChange={e => setModel_osvmd_print_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>

                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Data</Box>
                                <Grid container>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum data price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_osvmd_export_minFixed} onChange={e => setModel_osvmd_export_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>
                                </Grid>
                            </div>
                            </Grid>
                            <Grid item xs={12} >
                            <div className={classes.productcontainer}>

                                <Box className={classes.containerLabel} fontWeight="500" fontStyle="italic" fontSize={16} >Ordnance Survey Openmap Local</Box>
                                <Box className={classes.containerLabel} fontSize={12} >Views</Box>
                                <Grid container>
                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Price per km</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_osoml_view_price} onChange={e => setModel_osoml_view_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>
                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Plots</Box>
                                <Grid container>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum plot price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_osoml_print_minFixed} onChange={e => setModel_osoml_print_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>

                                </Grid>
                                <Box className={classes.containerLabel} fontSize={12} >Data</Box>
                                <Grid container>

                                        <Grid item xs={4} md={2}>
                                            <Box fontSize={12} >Minimum data price</Box>
                                        </Grid>
                                        <Grid item xs={4} md={2}>
                                            <TextField className={classes.modelField} value={model_osoml_export_minFixed} onChange={e => setModel_osoml_export_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={4} md={8}></Grid>
                                </Grid>
                            </div>
                            </Grid>
                            <Grid item xs={12} >
                            <div className={classes.productcontainer}>
                                    <Box className={classes.containerLabel} fontWeight="500" fontStyle="italic" fontSize={16} >OS Vectormap Local (Vector)</Box>
                                    <Box className={classes.containerLabel} fontSize={12} >Views</Box>


                                    <Grid container>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >1st km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_osvml_view_threshold_price} onChange={e => setModel_osvml_view_threshold_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >Price per km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_osvml_view_band1_price} onChange={e => setModel_osvml_view_band1_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                    </Grid>
                                    <Box className={classes.containerLabel} fontSize={12} >Plots</Box>
                                    <Grid container>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >Minimum plot price</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_osvml_print_minFixed} onChange={e => setModel_osvml_print_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>

                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >1st km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_osvml_print_threshold_price} onChange={e => setModel_osvml_print_threshold_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >Price per km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_osvml_print_band1_price} onChange={e => setModel_osvml_print_band1_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                    </Grid>
                                    <Box className={classes.containerLabel} fontSize={12} >Data</Box>
                                    <Grid container>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >Minimum data price</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_osvml_export_minFixed} onChange={e => setModel_osvml_export_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>

                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >Price per km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_osvml_export_band1_price} onChange={e => setModel_osvml_export_band1_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                    </Grid>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <div className={classes.productcontainer}>
                                    <Box className={classes.containerLabel} fontWeight="500" fontStyle="italic" fontSize={16} >OS Mastermap</Box>
                                    <Box className={classes.containerLabel} fontSize={12} >Views</Box>
                                    <Grid container>
                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >Band</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Settlement (per hectare)</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Rural (per hectare)</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Moorland (per hectare)</Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >A</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <TextField className={classes.modelField} value={model_osmm_view_threshold_price} onChange={e => setModel_osmm_view_threshold_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={3} md={2}>

                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >B</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <TextField className={classes.modelField} value={model_osmm_view_band1_high_price} onChange={e => setModel_osmm_view_band1_high_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <TextField className={classes.modelField} value={model_osmm_view_band1_med_price} onChange={e => setModel_osmm_view_band1_med_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <TextField className={classes.modelField} value={model_osmm_view_band1_low_price} onChange={e => setModel_osmm_view_band1_low_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >C</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <TextField className={classes.modelField} value={model_osmm_view_band2_high_price} onChange={e => setModel_osmm_view_band2_high_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <TextField className={classes.modelField} value={model_osmm_view_band2_med_price} onChange={e => setModel_osmm_view_band2_med_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <TextField className={classes.modelField} value={model_osmm_view_band2_low_price} onChange={e => setModel_osmm_view_band2_low_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>
                                    </Grid>
                                    <Box className={classes.containerLabel} fontSize={14} >Plots</Box>
                                    <Grid container>
                                        <Grid item xs={2} />
                                        <Grid item xs={2} >
                                            <Box fontSize={12} >A4</Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} >A3</Box>
                                        </Grid>
                                        <Grid item xs={6} />
                                        <Grid item xs={2} >
                                            <Box fontSize={12} >Fixed Price @ 200</Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_200_a4} onChange={e => setModel_osmm_print_200_a4(e.target.value)} name="price" label="price @A4" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_200_a3} onChange={e => setModel_osmm_print_200_a3(e.target.value)} name="price" label="price @A3" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={2} >
                                            <Box fontSize={12} >Fixed Price @ 500</Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_500_a4} onChange={e => setModel_osmm_print_500_a4(e.target.value)} name="price" label="price @A4" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_500_a3} onChange={e => setModel_osmm_print_500_a3(e.target.value)} name="price" label="price @A3" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={2} >
                                            <Box fontSize={12} >Fixed Price @ 1250</Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_1250_a4} onChange={e => setModel_osmm_print_1250_a4(e.target.value)} name="price" label="price @A4" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_1250_a3} onChange={e => setModel_osmm_print_1250_a3(e.target.value)} name="price" label="price @A3" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={2} >
                                            <Box fontSize={12} >Fixed Price @ 2500</Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_2500_a4} onChange={e => setModel_osmm_print_2500_a4(e.target.value)} name="price" label="price @A4" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={2} >
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_2500_a3} onChange={e => setModel_osmm_print_2500_a3(e.target.value)} name="price" label="price @A3" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={6}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >Standard Pricing Band</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Settlement</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Rural</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Moorland</Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >A</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_threshold_price} onChange={e => setModel_osmm_print_threshold_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ></Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >B</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_band1_high_price} onChange={e => setModel_osmm_print_band1_high_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_band1_med_price} onChange={e => setModel_osmm_print_band1_med_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_band1_low_price} onChange={e => setModel_osmm_print_band1_low_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >C</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_band2_high_price} onChange={e => setModel_osmm_print_band2_high_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_band2_med_price} onChange={e => setModel_osmm_print_band2_med_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_print_band2_low_price} onChange={e => setModel_osmm_print_band2_low_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                    </Grid>
                                    <Box className={classes.containerLabel} fontSize={12} >Data</Box>
                                    <Grid container>
                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >Band</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Minimum data price</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Fixed 1ha</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Fixed 4ha</Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} ></Box>
                                        </Grid>

                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_minFixed} onChange={e => setModel_osmm_export_minFixed(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                        <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_fixed_1ha} onChange={e => setModel_osmm_export_fixed_1ha(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                        <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_fixed_4ha} onChange={e => setModel_osmm_export_fixed_4ha(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >Band</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Settlement</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Rural</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} >Moorland</Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >A</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_threshold_price} onChange={e => setModel_osmm_export_threshold_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ></Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >B</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_band1_high_price} onChange={e => setModel_osmm_export_band1_high_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_band1_med_price} onChange={e => setModel_osmm_export_band1_med_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_band1_low_price} onChange={e => setModel_osmm_export_band1_low_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>

                                        <Grid item xs={3} md={2} >
                                            <Box fontSize={12} >C</Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_band2_high_price} onChange={e => setModel_osmm_export_band2_high_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_band2_med_price} onChange={e => setModel_osmm_export_band2_med_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={3} md={2}>
                                            <Box fontSize={12} ><TextField className={classes.modelField} value={model_osmm_export_band2_low_price} onChange={e => setModel_osmm_export_band2_low_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required /></Box>
                                        </Grid>
                                        <Grid item xs={false} md={4}></Grid>
                                    </Grid>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                            <div className={classes.productcontainer}>
                                    <Box className={classes.containerLabel} fontWeight="500" fontStyle="italic" fontSize={16} >Aerial Imagery</Box>
                                    <Box className={classes.containerLabel} fontSize={12} >Views</Box>
                                    <Grid container>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >Price per km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_aerial_view_threshold_price} onChange={e => setModel_aerial_view_threshold_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                    </Grid>
                                    <Box className={classes.containerLabel} fontSize={12} >Plots</Box>
                                    <Grid container>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >1st km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_aerial_print_threshold_price} onChange={e => setModel_aerial_print_threshold_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                            <Grid item xs={4} md={2}>
                                                <Box fontSize={12} >Price per km</Box>
                                            </Grid>
                                            <Grid item xs={4} md={2}>
                                                <TextField className={classes.modelField} value={model_aerial_print_band1_price} onChange={e => setModel_aerial_print_band1_price(e.target.value)} name="price" label="price" type="number" error={hasError} size="small" margin="dense" variant="outlined" required />
                                            </Grid>
                                            <Grid item xs={4} md={8}></Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
  };
